import { SetWithdrawals } from './thunk/setWithdrawals'

export const Thunks = {
    SetWithdrawals
}